<template>
  <div id="virtualPlayerPreviewIframeWrapper">
    <template v-if="player && ['svg', 'html'].indexOf(player.preview.type) >= 0">
      <iframe id="virtualPlayerPreviewIframe"
        @load="handleSVGOnLoad"
        :src="$utils.filterMediaPreviewUrl(player.preview.url)"
        :data-src="$utils.trimDataSrc(player.preview.url)"
        :class="['object-fit_cover_center', 'template-target-on-refresh-token', 'media-project-file', `media-preview-${player._edit.uid}`]">
      </iframe>
    </template>
  </div>
</template>

<script src="./virtual-player-iframe.js"></script>
<style lang="scss" src="./virtual-player-iframe.scss"></style>
